<template>
  <div>
    <cityinfo-header></cityinfo-header>
    <section
      id="home"
      class="k12-banner py-md-5 pt-md-0 pt-sm-5 pt-4"
    ></section>
    <section class="w3l-new-block-6 py-5">
      <div class="container py-md-4 py-3">
        <div class="main-content">
          <div class="title-heading-w3 text-center mx-auto">
            <h3 class="title-main">{{ activity.title }}</h3>
          </div>
          <!-- blog section -->
          <div class="title-heading-w3 mx-auto">
            <div v-html="activity.content"></div>
          </div>
          <div class="title-heading-w3 mx-auto left-insp-art">
            <ul>
              <li v-for="(item, i) in activity.files" :key="i" :value="item.key">
              <a
                :href="getFilePreviewUrl(item)"
                target="_blank"
                class="btn  btn-lg w-100"
              >
                <span class="download"><i class="las la-download"></i></span>
                {{ item.name }}
              </a>
              </li>
            </ul>
          </div>
          <div class="row content-sec mt-md-5 mt-4 justify-content-md-center">
            <div class="text-center">
              <div class=" btn btn-style w3l-form-26">
              <button
                type="button"
                class="btn"
                @click="signup"
                :disabled="!activity.id"
              >
                <span v-if="activity.id" class="text">前往報名</span>
                <span v-if="!activity.id" class="text">目前沒有活動</span>
              </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <cityinfo-footer></cityinfo-footer>
  </div>
</template>
<script>
import header from "../header";
import footer from "../footer";
export default {
  components: {
    "cityinfo-header": header,
    "cityinfo-footer": footer,
  },
  data() {
    return {
      activity: {
        title: "",
        content: "",
      },
    };
  },
  mounted() {
    var url = "/api/leaderTrainingCamp";
    this.$http.get(url).then(
      (response) => {
        if (response.body) {
          this.activity = response.body;
        } else {
          // do nothing
        }
      },
      (error) => {
          bootbox.alert("系統發生錯誤，請聯絡系統管理員", function () {
            window.location.href = "/";
          });
      }
    );
  },
  methods: {
    signup() {
      this.gotoView("leaderTrainingCamp.applicant", {
        activityId: this.activity.id,
      });
    },
    // 預覽檔案
    getFilePreviewUrl(fileOrUrl) {
      // 使用者剛上傳的 File 物件
      if (fileOrUrl instanceof File || fileOrUrl instanceof Blob) {
        return URL.createObjectURL(fileOrUrl);
      }

      // 後端提供的 URL（假設為字串）
      if (typeof fileOrUrl === "string" && fileOrUrl.startsWith("/")) {
        return fileOrUrl;
      }

      // 後端提供 object 物件
      if (typeof fileOrUrl === "object" && fileOrUrl.url) {
        return fileOrUrl.url;
      }

      // 如果都不是，則返回空字串或其他預設值
      return "";
    },
  },
  watch: {},
  beforeRouteLeave(to, from, next) {
    this.removeStore(this.$route.name);
    next();
  },
};
</script>
<style>
/*-- banner --*/
.k12-banner {
  background: url(~@/assets/images/k12-banner.jpg) no-repeat center;
  -ms-background-size: cover;
  background-size: cover;
  position: relative;
  min-height: 600px;
}

.title-decoration {
  position: absolute;
  width: 2%;
  height: 90%;
  background-color: #365b6d;
}
@media (min-width: 1366px) {
  .title-decoration {
    margin-top: -1%;
    margin-left: -5%;
  }
}
@media (max-width: 1366px) {
  .title-decoration {
    margin-top: -1%;
    margin-left: -5%;
  }
}
@media (max-width: 900px) {
  .title-decoration {
    margin-top: -1%;
    margin-left: 2%;
  }
}
@media (max-width: 736px) {
  .title-decoration {
    margin-top: -1%;
    margin-left: 2%;
  }
  .k12-banner {
    background: url(~@/assets/images/k12-banner-mobile.jpg) no-repeat center;
    -ms-background-size: cover;
    background-size: 100%;
    position: relative;
    min-height: 450px;
  }
}
@media only screen and (max-device-height: 736px) {
  .k12-banner {
    min-height: 250px;
  }
}
</style>
